import React from "react";
import { motion } from "framer-motion";
import { howItWorks, buildWhatsAppLink } from "../data/menu";
import { UtensilsCrossed, MessageCircle, Home } from "lucide-react";

const stepIcons = [UtensilsCrossed, MessageCircle, Home];

const HowItWorks = () => {
  return (
    <section
      id="como-funciona"
      className="relative py-24 sm:py-32 bg-[var(--sn-bg-deep)] overflow-hidden"
      data-testid="howitworks-section"
    >
      <div className="absolute inset-0 sn-grain pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-10 bg-[var(--sn-gold)]" />
            <span className="text-[var(--sn-gold)] tracking-[0.3em] text-xs uppercase">
              Como Funciona
            </span>
            <span className="h-px w-10 bg-[var(--sn-gold)]" />
          </div>
          <h2
            className="font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--sn-cream)] mb-4"
            data-testid="howitworks-headline"
          >
            Em três passos,{" "}
            <span className="italic gold-text">a Itália na sua casa.</span>
          </h2>
        </div>

        <div className="relative">
          {/* Connecting line */}
          <div className="absolute top-12 left-12 right-12 h-px bg-gradient-to-r from-transparent via-[var(--sn-gold)]/40 to-transparent hidden md:block" />

          <div className="grid md:grid-cols-3 gap-10 md:gap-8 relative">
            {howItWorks.map((s, i) => {
              const Icon = stepIcons[i];
              return (
                <motion.div
                  key={s.step}
                  initial={{ opacity: 0, y: 25 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.6, delay: i * 0.15 }}
                  className="relative flex flex-col items-center text-center"
                  data-testid={`howitworks-step-${i}`}
                >
                  <div className="relative mb-7">
                    <div className="w-24 h-24 rounded-full bg-[var(--sn-bg-surface)] border border-[var(--sn-gold)] flex items-center justify-center relative z-10">
                      <Icon className="w-8 h-8 text-[var(--sn-gold)]" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-9 h-9 rounded-full bg-[var(--sn-gold)] text-[var(--sn-bg-deep)] font-display font-bold flex items-center justify-center text-sm z-20">
                      {s.step}
                    </div>
                  </div>

                  <h3 className="font-display text-2xl text-[var(--sn-cream)] mb-3">
                    {s.title}
                  </h3>
                  <p className="text-[var(--sn-cream-soft)]/75 leading-relaxed max-w-xs">
                    {s.desc}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>

        <div className="mt-16 text-center">
          <a
            href={buildWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-[var(--sn-whatsapp)] hover:bg-[var(--sn-whatsapp-hover)] text-white font-medium px-8 py-4 rounded-md transition-all hover:translate-y-[-2px]"
            data-testid="howitworks-cta-button"
          >
            Começar meu pedido agora
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
